// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton_base__SoWbW","active":"skeleton_active__ZTp8U","skeleton":"skeleton_skeleton__oIvnu"};